/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
import {useTranslation} from 'react-i18next'
import React from 'react'
import clsx from 'clsx'
import { closeModal } from 'helpers/actions'
import { useAppDispatch } from 'helpers/store'
import { XMarkIcon } from '@heroicons/react/24/outline'

const ModalScrollableClose = () => {
    const {t} = useTranslation()
    const dispatch = useAppDispatch()

    const onCloseModalHandler = () => {
        dispatch(closeModal())
    }

    return (
        <button
            type="button"
            aria-label={t('Close')}
            className={clsx(
                'ModalScrollableClose print:hidden sticky top-3 ml-auto mr-3 z-100',
                'rounded-md p-1.5 text-gray-400 transition-colors',
                'hover:bg-gray-100 hover:text-gray-600',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-cta-light/40',
                'dark:text-gray-500 dark:hover:bg-gray-800 dark:hover:text-gray-300'
            )}
            onClick={onCloseModalHandler}
        >
            <XMarkIcon className="h-5 w-5" aria-hidden="true" />
        </button>
    )
}

export default ModalScrollableClose
